import { Collapse, Typography } from "@material-ui/core";

import { Alert } from "ra-friendsofbabba";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useFormState } from "react-final-form";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  message: {
    width: "100%",
  },
}));

const DirtyAlert = ({ message }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const { dirty } = useFormState({ subscription: { dirty: true } });

  return (
    <Collapse in={dirty}>
      <Alert elevation={1} severity="info" className={classes.root}>
        <Typography variant="body1" className={classes.message}>
          <span
            dangerouslySetInnerHTML={{
              __html: translate(message),
            }}
          />
        </Typography>
      </Alert>
    </Collapse>
  );
};
export default DirtyAlert;
